import { todayPT } from "@homebound/activesupport";
import { Css } from "@homebound/beam";
import { Temporal } from "temporal-polyfill";

export enum BudgetMetricsViewType {
  MTD = "Month-to-date",
  QTD = "Quarter-to-date",
  YTD = "Year-to-date",
  ALL_TIME = "All time",
}

type ViewTypeFilterProps = {
  viewType: BudgetMetricsViewType;
  setViewType: React.Dispatch<React.SetStateAction<BudgetMetricsViewType>>;
};

export function ViewTypeFilter({ viewType, setViewType }: ViewTypeFilterProps) {
  return (
    <div css={Css.br4.ba.bcGray300.bgWhite.df.mla.$}>
      <button
        css={Css.sm.br.wPx(60).bcGray300.if(viewType === BudgetMetricsViewType.MTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.MTD)}
      >
        MTD
      </button>
      <button
        css={Css.sm.br.bcGray300.wPx(60).if(viewType === BudgetMetricsViewType.QTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.QTD)}
      >
        QTD
      </button>
      <button
        css={Css.sm.br.bcGray300.wPx(60).if(viewType === BudgetMetricsViewType.YTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.YTD)}
      >
        YTD
      </button>
      <button
        css={Css.sm.p1.wPx(86).if(viewType === BudgetMetricsViewType.ALL_TIME).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.ALL_TIME)}
      >
        All Time
      </button>
    </div>
  );
}

export function getFromDate(viewType: BudgetMetricsViewType, snapshot?: boolean): Temporal.PlainDate | undefined {
  const today = todayPT();
  switch (viewType) {
    case BudgetMetricsViewType.MTD:
      return today.with({ day: 1 });
    case BudgetMetricsViewType.QTD:
      return today.with({ month: quarterStartMonth(today.month), day: 1 });
    case BudgetMetricsViewType.YTD:
      return today.with({ month: 1, day: 1 });
    default:
      // TODO: handle "ALL_TIME" case for snapshots, we'd need to return the first usable snapshot for the project.
      return snapshot ? today.with({ year: decadeStartYear(today.year), month: 1, day: 1 }) : undefined;
  }
}

function quarterStartMonth(month: number) {
  return Math.floor((month - 1) / 3) * 3 + 1;
}

function decadeStartYear(year: number) {
  return year - (year % 10);
}
